import React from 'react';
import { Link } from 'react-router-dom';

export default class Navigation extends React.Component {

  onClick(handler) {
    handler();
  }

  render() {
    return (
      <nav className="top-nav pc">
        <ul className="k-t-nav">
          <li className="btnmode" onClick={this.onClick.bind(this, this.props.mapSelectHandler)}><a><div className="k-nav-icon k-nav-icon1"></div><span className="nav-icon-txt">地図選択</span></a></li>
          <Link to="/kenchiku/manual" target="_blank"><li className="btnmode"><div className="k-nav-icon k-nav-icon2"></div><span className="nav-icon-txt">操作説明</span></li></Link>
          <li className="btnmode" onClick={this.onClick.bind(this, this.props.usageBoxHandler)}><a><div className="k-nav-icon k-nav-icon3"></div><span className="nav-icon-txt">凡例</span></a></li>
          <Link to="/kenchiku/print"><li className="btnmode"><div className="k-nav-icon k-nav-icon4"></div><span className="nav-icon-txt">印刷</span></li></Link>
        </ul>
      </nav>
    );
  }

}